import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../Styles/ValuatorStyles/ValuatorNavbar.css'
import { Link } from 'react-router-dom';
import useNavigation from '../hooks/useNavigation';
import EasyAdminLogo from '../Images/EasyAdminLogo.png'

const ValuateNavbar = () => {
        const { navigateTo } = useNavigation();
        const { logout, isAdmin } = useAuth();
      
      
        const onAdminClick = () => {
          navigateTo('/valuator/admin-panel');
        }
        const onValuatorClick = () => {
          navigateTo('/');
        }

        return (
          <nav className='navbar'>
            <div className='navbar-container'>
              <Link to='/valuator' className='navbar-logo'>
                <img className='navbar-logo' src={EasyAdminLogo} alt='logo'></img>
              </Link>
              

              <div>
              {isAdmin && <button className='admin-btn me-5' onClick={onValuatorClick}>MånedsrapportApp</button>}
              {isAdmin && <button className='admin-btn' onClick={onAdminClick}>Admin-Panel</button>}
              <button className='logout-btn' onClick={logout}>Logout</button>
              </div>
            </div>
          </nav>
        );
      };
      
      export default ValuateNavbar;
      